import Cookies from "js-cookie"

export const getToken = () => {
  const token = Cookies.get("token")
  if (token) {
    return token
  } else {
    return null
  }
}

export const isAuthenticated = () => {
  return !!getToken()
}
